







































































































































































































































import Vue from "vue";
import store, { TransactionStore } from "../services/TransactionStore";
import DateInput from "@/components/DateInput.vue";
import SpecialDimensionButton from "@/components/SpecialDimensionButton.vue";
import PartnerSearch from "@/modules/partner/views/PartnerSearch.vue";
import Partner from "@/modules/partner/models/Partner";
import Transaction from '../models/Transaction'


interface Data {
    store: TransactionStore;
}
interface Method{
    onPartnerChange(partner: Partner): void;
    onDateChange(date: Date): void;
    onTransTypeChange(type: any): void;
    onValueChange(item: Transaction): void;
    onSpecDimSaved(rows: { specDimType: number; note: string }[]): void;
}
interface Computed {
    editing: boolean;
    itemsHaveSpecDim: boolean;
}

export default Vue.extend<Data, Method, Computed, {}>({
    components: {
        DateInput,
        PartnerSearch,
        SpecialDimensionButton
    },
    methods: {
        async onPartnerChange(partner) {
            this.store.transaction.partner = partner.id;
            this.store.transaction.partnerName = partner.name;

            store.transactionItems.forEach(el =>{
                if(el.partner != partner.id){
                    el.partner = partner.id;
                    const exists = this.store.modifiedItems.some(x => x.id === el.id);
                    if (!exists) {
                        this.store.modifiedItems.push(el);
                    } 
                }
            })
        },
        async onDateChange(dateVal){
            const date = new Date(dateVal);
            const dateString = date.getFullYear() + "." + String(date.getMonth() + 1).padStart(2, "0") + "." + String(date.getDate()).padStart(2, "0")
            const dateISOString = date.toISOString().slice(0, 19);

            const period = await this.store.getPeriod(dateString)
            store.transaction.periodName = (period as any).period
            store.transaction.period = (period as any).id

            store.transactionItems.forEach(el =>{
                if(el.period != (period as any).id){
                    el.period = (period as any).id
                    const exists = this.store.modifiedItems.some(x => x.id === el.id);
                    if (!exists) {
                        this.store.modifiedItems.push(el);
                    }
                }
                if(el.accDate != dateISOString){
                    el.accDate = dateISOString
                    const exists = this.store.modifiedItems.some(x => x.id === el.id);
                    if (!exists) {
                        this.store.modifiedItems.push(el);
                    }
                }

            })

        },
        onTransTypeChange(item){
            store.transaction.typeName = item.name
            store.transaction.transType = item.id
        },
        // A fej spec dimjeit a SpecialDimensionButton közvetlenül a DB-be menti — a store-beli
        // fejet is frissíteni kell, hogy a tétel-grid spec dim tiltása azonnal kövesse.
        onSpecDimSaved(rows){
            for (const row of rows ?? []) {
                const note = row.note ?? "";
                if (row.specDimType === 1) store.transaction.specDim1 = note;
                if (row.specDimType === 2) store.transaction.specDim2 = note;
                if (row.specDimType === 3) store.transaction.specDim3 = note;
                if (row.specDimType === 4) store.transaction.specDim4 = note;
            }
        },
        onValueChange(item){
            const ogTrans = item.id == store.originalTransaction.id ? store.originalTransaction : null;
            if(ogTrans == null)
                return

            const fieldsToCheck: (keyof Transaction)[] = ['accEvent','remark','partner','accDate','transType']
            const hasKey = (key: keyof Transaction) =>
                this.store.modifiedTransaction.some(x => Object.prototype.hasOwnProperty.call(x, key));

            for (const key of fieldsToCheck) {
                let isChanged: boolean;
                if(key == "accDate"){
                    const itemDate = new Date(item[key]).toISOString().split('T')[0];
                    isChanged = itemDate != ogTrans[key];
                }
                else {
                    isChanged = item[key] != ogTrans[key];
                }

                if(isChanged){
                    if (!hasKey(key)) {
                        this.store.modifiedTransaction.push({[key]: item[key]})
                    }
                }else{
                    this.store.modifiedTransaction = this.store.modifiedTransaction.filter(x => !Object.prototype.hasOwnProperty.call(x, key))
                }
            }
        }
    },

    data() {
        return {
            store,
        };
    },

    computed: {
        // Computed, NEM data-snapshot: a store singleton, a fej async töltődik — data()-ban
        // felvéve az ELŐZŐLEG megnyitott (pl. view-olt, >3 státuszú) tranzakció státusza ragadt
        // volna be, és a friss 2-es státuszú fej inputjai is tiltva maradtak.
        editing(): boolean {
            return this.store.transaction.status > 3;
        },
        // Fej↔tétel kizárás: ha bármely tételen van spec dim (a grid élő, mentetlen értékeit is
        // beleértve), a fej spec dim gombja tiltott — előbb a tételekről kell törölni.
        itemsHaveSpecDim(): boolean {
            return this.store.transactionItems.some(x =>
                !!(x.specDim1 || x.specDim2 || x.specDim3 || x.specDim4));
        },
    },
});
